import reviews from "./mountain-official-reviews.json";

export type OfficialMountainReview = Readonly<{
  checkedOn: string;
  officialMapUrl: string | null;
  reviewDepth: "source-location" | "scope-and-access" | "feature-metadata";
  edition: string | null;
  note: string;
  sourceAssessment: "operator-reference" | "authority-unresolved" | "source-unavailable";
  needsRefresh: boolean;
}>;

/** A dated source observation, never a route, opening or Companion approval. */
export function officialMountainReviewForArea(areaSlug: string | null | undefined, now = new Date()): OfficialMountainReview | null {
  if (!areaSlug || !Object.hasOwn(reviews, areaSlug)) return null;
  const review = reviews[areaSlug as keyof typeof reviews];
  const checked = Date.parse(`${review.checkedOn}T00:00:00Z`);
  const age = now.getTime() - checked;
  return { ...review, reviewDepth: review.reviewDepth as OfficialMountainReview["reviewDepth"],
    sourceAssessment: review.sourceAssessment as OfficialMountainReview["sourceAssessment"],
    needsRefresh: !Number.isFinite(age) || age < 0 || age >= 30 * 86400000 };
}

export function officialMountainReviewDate(checkedOn: string): string {
  return new Date(`${checkedOn}T00:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
}
